document.addEventListener("DOMContentLoaded", function() {
  function setEqualHeight() {
    const cards = document.querySelectorAll('.product-card__inner');
    let maxHeight = 0;

    // Reset height
    cards.forEach(card => card.style.height = 'auto');

    // Find max height
    cards.forEach(card => {
      const cardHeight = card.offsetHeight;
      if(cardHeight > maxHeight) maxHeight = cardHeight;
    });

    // Apply max height
    cards.forEach(card => card.style.height = maxHeight + 'px');
  }

  setEqualHeight();
  window.addEventListener('resize', setEqualHeight); // Responsive
});
